import { Controller } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import classNames from 'classnames';
import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';

export default function LinkComponent({ control, name, disabled = false }) {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        pattern: {
          value: /^(http|https):\/\/[^\s$.?#].[^\s]*$/,
          message: 'Invalid URL. Please enter a valid http or https URL.',
        },
      }}
      render={({ field, fieldState }) => (
        <>
          <InputText
            placeholder="http://example.com or https://example.com"
            id={field.name}
            value={field.value || ''}
            onChange={(e) => field.onChange(e.target.value)}
            className={classNames({
              'p-invalid': fieldState.invalid,
              'input-shadow w-100': true,
            })}
            disabled={disabled}
          />
          {fieldState.error?.message && <InputErrorMessage>{fieldState.error.message}</InputErrorMessage>}
        </>
      )}
    />
  );
}
